import * as React from "react";
import { IOWidget, mk_widget } from "../widget";

export interface ShouldComponentUpdateProps<s> {
  p:(prev:s, next:s) => boolean,
  input:s
  widget_s:IOWidget<s,s>
  on_done_s:(output_s:s) => void
}
export interface ShouldComponentUpdateState<_s> { }

/**
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
 */
export class ShouldComponentUpdate<s> extends React.Component<ShouldComponentUpdateProps<s>, ShouldComponentUpdateState<s>> {
  constructor(props:ShouldComponentUpdateProps<s>, context:any) {
    super(props, context)

    this.state = {}
  }

  shouldComponentUpdate(nextProps:ShouldComponentUpdateProps<s>) {
    return this.props.p(this.props.input, nextProps.input)
  }

  render() {
    return this.props.widget_s(this.props.input).run(new_s => this.props.on_done_s(new_s))
  }
}
export const shouldComponentUpdate = function<s>(p:(prev:s, next:s) => boolean) : (widget_s:IOWidget<s,s>) => IOWidget<s,s> {
  return widget_s => (input:s) => mk_widget({
    run:(on_done_s:(output:s) => void) =>
      React.createElement<ShouldComponentUpdateProps<s>>(ShouldComponentUpdate, { on_done_s, widget_s, input, p })
  })
}
